// extracted by mini-css-extract-plugin
export default {"container":"base-text-outline-options-module__container--zf6oH"};